import React from 'react';

const FormDestete = ({ formDatos, setFormDatos, animalEncontrado }) => {
  // Show madre info if the scanned animal is a ternero with madre
  const esTernero = animalEncontrado?.madre_id;

  return (
    <div className="space-y-3">
      {esTernero && (
        <div className="p-2 bg-blue-50 border border-blue-200 rounded-lg text-xs text-blue-700">
          Madre vinculada: {animalEncontrado.madre_vid || animalEncontrado.madre_id?.slice(0, 8)}
        </div>
      )}
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3">
        <div>
          <label className="block text-xs font-medium text-gray-700 mb-1">Peso Ternero (kg) *</label>
          <input type="number" step="0.1" value={formDatos.peso_ternero || ''} onChange={(e) => setFormDatos(p => ({ ...p, peso_ternero: e.target.value }))}
            placeholder="180" className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-green-500" data-testid="campo-peso-ternero" autoFocus />
        </div>
        <div>
          <label className="block text-xs font-medium text-gray-700 mb-1">Fecha Destete</label>
          <input type="date" value={formDatos.fecha_destete || new Date().toISOString().split('T')[0]} onChange={(e) => setFormDatos(p => ({ ...p, fecha_destete: e.target.value }))}
            className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm" />
        </div>
        <div>
          <label className="block text-xs font-medium text-gray-700 mb-1">Peso Madre (kg)</label>
          <input type="number" step="0.1" value={formDatos.peso_madre || ''} onChange={(e) => setFormDatos(p => ({ ...p, peso_madre: e.target.value }))}
            placeholder="450" className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm" data-testid="campo-peso-madre" />
          <p className="text-xs text-gray-400 mt-0.5">Si ya peso la madre en otra sesion, dejar vacio</p>
        </div>
        <div>
          <label className="block text-xs font-medium text-gray-700 mb-1">VID Madre</label>
          <input type="text" value={formDatos.madre_vid || ''} onChange={(e) => setFormDatos(p => ({ ...p, madre_vid: e.target.value }))}
            placeholder="VID de la madre" className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm" data-testid="campo-madre-vid" />
          <p className="text-xs text-gray-400 mt-0.5">Si el ternero ya tiene madre vinculada, dejar vacio</p>
        </div>
        <div>
          <label className="block text-xs font-medium text-gray-700 mb-1">Condicion Corporal Madre (1-9)</label>
          <select value={formDatos.cc_madre || ''} onChange={(e) => setFormDatos(p => ({ ...p, cc_madre: e.target.value }))}
            className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm">
            <option value="">--</option>
            {[1,2,3,4,5,6,7,8,9].map(n => <option key={n} value={n}>{n}</option>)}
          </select>
        </div>
        <div>
          <label className="block text-xs font-medium text-gray-700 mb-1">Observaciones</label>
          <input type="text" value={formDatos.observaciones || ''} onChange={(e) => setFormDatos(p => ({ ...p, observaciones: e.target.value }))}
            placeholder="Notas..." className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm" />
        </div>
      </div>
      {formDatos.peso_ternero && formDatos.peso_madre && (
        <div className="p-3 bg-green-50 border border-green-200 rounded-lg">
          <p className="text-sm font-semibold text-green-800">
            EP = {(parseFloat(formDatos.peso_ternero) / parseFloat(formDatos.peso_madre) * 100).toFixed(1)}%
            <span className="text-xs text-green-600 ml-2">(Peso ternero / Peso madre x 100)</span>
          </p>
        </div>
      )}
    </div>
  );
};

export default FormDestete;
